import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const DataDisposalMethodSchema = BigdesDefinitionSchema.extend({});
export const CreateDataDisposalMethodSchema = DataDisposalMethodSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateDataDisposalMethodSchema = DataDisposalMethodSchema.partial();
